/**
 * 404 Not Found Page.
 *
 * Displayed when the user navigates to a route that doesn't match any
 * defined paths. Provides a link back to the dashboard.
 */

import { Link } from "react-router-dom";

function NotFoundPage() {
  return (
    <div className="page-narrow flex flex-col items-center justify-center py-24">
      <h2 className="text-6xl font-bold text-[var(--text-tertiary)]">404</h2>
      <p className="mt-4 text-lg text-[var(--text-secondary)]">
        Page not found
      </p>
      <Link
        to="/"
        className="mt-6 rounded-[var(--radius-md)] bg-[var(--color-interactive-primary-hover)] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-800"
      >
        Back to Dashboard
      </Link>
    </div>
  );
}

export default NotFoundPage;
